<template>
  <div>
    <label class="label-modal">Imagem</label>
    <div v-if="!isImage">
      <input
        accept="image/*"
        hidden="hidden"
        name="file"
        id="file-1"
        class="inputfile inputfile-1"
        type="file"
        ref="file"
        @change="onFileChange"
      />
      <label class="d-flex justify-center" for="file-1">
        <v-icon x-large>mdi-cloud-upload</v-icon>
      </label>
    </div>
    <div v-else>
      <v-flex xs12 sm6 md12 class="img-loader">
        <v-btn class="removeImageBtn" @click.native="removeImage" text icon color="red lighten-1">
          <v-icon color="red lighten-1">cancel</v-icon>
        </v-btn>
        <img v-if="file" id="img-upload" :src="this.image" width="100%" loading="lazy" />
        <img
          v-else
          id="img-upload"
          loading="lazy"
          :src="
            $imagemsUrl +'/' + MyObject.image
            "
          width="100%"
        />
      </v-flex>
    </div>
  </div>
</template>
<script>
import CRUD from "@/mixins/_CRUD"
export default {
  mixins: [CRUD],
  props: {
    MyObject: Object
  },
  data: () => ({
    file: "",
    image: "",
    isImage: false,
    imgWidth: 50
  }),
  watch: {
    MyObject(val) {
      this.isImage = !(val.image == null)
    }
  },
  created() {
    this.$eventBus.$on("ClearImage", () => {
      this.image = this.file = ""

      this.isImage = false
    })
  },
  mounted() {
    setTimeout(() => {
      this.isImage = !(this.MyObject.image == null)
    }, 110)
  },

  methods: {
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return

      this.file = this.$refs.file.files[0]

      this.createImage(files[0])
    },
    createImage(file) {
      var reader = new FileReader()

      reader.onload = e => {
        this.image = e.target.result
        setTimeout(() => {
          this.MyObject.image = e.target.result
          this.MyObject.changeImage = true
          this.isImage = true
        }, 100)
      }
      reader.readAsDataURL(file)
    },
    removeImage: function(e) {
      this.image = this.file = ""
      setTimeout(() => {
        this.MyObject.image = null
        this.MyObject.changeImage = true
        this.isImage = false
      }, 100)
    }
  }
}
</script>
<style scoped>
.removeImageBtn {
  position: absolute !important;
  top: -30px !important;
  right: -30px !important;
}

.img-loader {
  position: relative !important;
  margin-top: 30px !important;
  max-width: fit-content !important;
}
</style>
